export default "__VITE_ASSET__27ceb1e1__"